/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { Alert } from "react-bootstrap";
import Spinner from '../../../../partials/layout/Spinner';
import * as compensationEventCrud from '../../../../crud/compensationEvent.crud';
import * as quotationCrud from '../../../../crud/quotation.crud';
import { injectIntl } from "react-intl";

class VariationOrderCustomForm extends React.Component {
    constructor(props) {
        super(props);
        this.createDefaultSubject = (((props.location || {}).state || {}).itemCustomProps || {}).subject;
        this.createDefaultAsset = (((props.location || {}).state || {}).itemCustomProps || {}).assetid;
        this.createDefaultFields = ((props.location || {}).state || {});

        this.validatorRef = props.validatorRef ? props.validatorRef : React.createRef();

        let selectedClause = null;

        const { fields } = props.workflowItem;

        //if it's coming from create new via Clause/Type button, try to set default clause display value according to the clauseDisplay passed in location state from clause dropdown
        const createDefaultClause = (((props.location || {}).state || {}).itemCustomProps || {}).clauseDisplay;

        if (fields.CompensationType?.clauses) {
            if (createDefaultClause) {
                selectedClause = fields.CompensationType.clauses.find(
                    c => c.display === createDefaultClause
                );
            }
            else if (props.item?.compensationtype) {
                selectedClause = fields.CompensationType.clauses.find(
                    c => c.display === props.item.compensationtype
                );
            }
        }

        this.state = {
            item: null,
            selectedClause,
            // clauseeffect: null,
            cenSelection: null,
        };
    }
    componentDidMount() {
        this.setItem();
    }
    getCompensationsDataSourceOptions = () => {
        const { contractid } = this.props.contract;
        const assessmentStates = ['APMV'];
        const datasource = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                var promise = new Promise(async (resolve) => {
                    const { data: responseObj } = await compensationEventCrud.getCompansationEventsToSelectList(contractid, assessmentStates);
                    let comps = responseObj.map(itm => {
                        return {
                            value: itm.compensationeventid,
                            referenceid: itm.referenceid,
                            subject: itm.compensationnumber,
                            type: itm.compensationsource,
                            display: `${itm.referenceid}   {${itm.compensationnumber}}`,
                            clauseeffect: itm.clauseeffect,
                        }
                    });
                    resolve(comps);
                });
                return promise;
            }
        }
        return datasource;
    }
    fetchRelatedCompensation = async (compensationId) => {
        try {
            const { data: relatedCompensation } = await compensationEventCrud.getCompensationEvent(compensationId);
            return relatedCompensation;
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            return null
        }
    }
    fetchRelatedQuotation = async (compensationId) => {
        try {
            const { data: relatedAcceptedQuote } = await quotationCrud.getAcceptedQuotation(compensationId);
            return relatedAcceptedQuote;
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            return null
        }
    }
    setItem = async () => {
        let relatedQuotation = null;
        let item = this.props.item || {};
        if (this.createDefaultFields?.itemBaseProps?.reftype === 'CompensationEvent' && this.createDefaultFields?.itemBaseProps?.refid) {
            //create page, redirected from create related button
            relatedQuotation = await this.fetchRelatedQuotation(this.createDefaultFields?.itemBaseProps?.refid);
            if (relatedQuotation) {
                item = {
                    otherdatechanges: JSON.parse(JSON.stringify(relatedQuotation.otherdatechanges)),
                    otherpricechanges: JSON.parse(JSON.stringify(relatedQuotation.otherpricechanges)),
                }
            }
        }

        //AUTO-SELECT CE DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
        let defaultCESelectionID = null;
        let cenSelection = null;
        if (this.createDefaultFields?.itemBaseProps?.reftype === 'CompensationEvent' && this.createDefaultFields?.itemBaseProps?.refid) {
            defaultCESelectionID = Number(this.createDefaultFields.itemBaseProps.refid);

        }
        if (defaultCESelectionID || item?.proposedcenid) {
            const compensationId = item?.proposedcenid ? item.proposedcenid : defaultCESelectionID;
            cenSelection = await this.fetchRelatedCompensation(compensationId);
        }

        this.setState({ item, cenSelection });

    }


    fieldChanged = (field, value, isDxFormValid, additionalData) => {
        this.state.isDxFormValid = isDxFormValid;

        if (field) {
            if (field === "proposedcenid") {
                console.log('fieldChanged:', additionalData);
                this.setState({ cenSelection: additionalData });
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);
                }
            } else {
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);
                }
                if (field === 'compensationtype') {
                    let selectedClause = null;
                    const { fields } = this.props.workflowItem;
                    if (value) {
                        selectedClause = fields.CompensationType.clauses.find(c => c.display === value);
                    }
                    this.setState({ selectedClause })
                }
            }
        }
    }

    render() {
        if (!this.state.item) {
            return (<Spinner />);
        }

        const { fields } = this.props.workflowItem;
        const { cenSelection } = this.state;
        const formFields = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: []
        };

        //AUTO-SELECT CE DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
        let defaultCESelectionID = null;
        if (this.createDefaultFields?.itemBaseProps?.reftype === 'CompensationEvent' && this.createDefaultFields?.itemBaseProps?.refid) {
            defaultCESelectionID = Number(this.createDefaultFields.itemBaseProps.refid);
        }

        formFields.fields.push({ label: fields.ProposedVariation.label, dataField: 'proposedcenid', editorType: 'dxSelectBox', editorOptions: { dataSource: this.getCompensationsDataSourceOptions(), valueExpr: 'value', displayExpr: 'display', defaultValue: defaultCESelectionID } });

        if (fields.Subject.visible) {
            formFields.fields.push({ label: fields.Subject.label, dataField: 'compensationnumber', editorOptions: { defaultValue: this.createDefaultSubject } });
        }
        if (fields.CompensationType.visible) {
            formFields.fields.push({ label: fields.CompensationType.label, dataField: 'compensationtype', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.CompensationType.clauses, valueExpr: 'display', displayExpr: 'display', defaultValue: this.state.selectedClause?.display } });
        }
        if (fields.PriceEffect.visible) {
            formFields.fields.push({
                visible: cenSelection?.clauseeffect !== "EFFECT_DATES_ONLY",
                label: fields.PriceEffect.label,
                dataField: 'assessmentamount',
                editorType: 'dxNumberBox',
                editorOptions: { defaultValue: this.createDefaultFields?.itemCustomProps?.priceeffect }
            });
        }
        if (fields.TimeEffect.visible) {
            formFields.fields.push({
                visible: cenSelection?.clauseeffect !== "EFFECT_AMOUNTS_ONLY",
                label: fields.TimeEffect.label,
                dataField: 'alternativequotation',
                editorType: 'dxNumberBox',
                editorOptions: { defaultValue: this.createDefaultFields?.itemCustomProps?.timeeffect, format: '#,##0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }) }
            });
        }
        if (fields.Details.visible) {
            formFields.fields.push({ label: fields.Details.label, dataField: 'description', editorType: 'dxHtmlEditor', editorOptions: { defaultValue: this.createDefaultFields?.itemCustomProps?.description } });
        }

        return (
            <div>
                {this.props.resources.VariationOrderWarningBanner && (
                    <Alert variant="warning" >
                        <span>
                            {
                                this.props.resources.VariationOrderWarningBanner.split("\n").map((line, index) => {
                                    return <div key={index}>{line}</div>
                                }
                                )
                            }
                        </span>
                    </Alert>
                )}
                <BiDynamicForm
                    validatorRef={this.validatorRef}
                    item={this.state.item}
                    config={formFields}
                    onSubmitHandler={this.props.onSubmitHandler}
                    valueChangeHandler={this.fieldChanged}
                    customFields={this.props.customFields}
                    assetFieldsEnabled={this.props.assetFieldsEnabled}
                    assetid={this.createDefaultAsset}
                    secondaryPriceSectionEnabled={cenSelection?.clauseeffect !== "EFFECT_DATES_ONLY"}
                    secondaryDateSectionEnabled={cenSelection?.clauseeffect !== "EFFECT_AMOUNTS_ONLY"}
                />
            </div>
        );
    }
}

const mapStateToProps = store => ({
    // contract: store.contract.contract,
    // contractTemplate: store.contract.template,
    // globalResources: store.contract.template.resources
});

export default injectIntl(withSnackbar(connect(mapStateToProps)(VariationOrderCustomForm)));